const testSessionStorageSupport = () => {
  const testKey = 'test';
  try {
    sessionStorage.setItem(testKey, '1');
    sessionStorage.removeItem(testKey);
    return true;
  } catch (error) {
    return false;
  }
};

const isSessionStorageSupported = testSessionStorageSupport();

const sessionRepository = {
  getItem(key) {
    if (isSessionStorageSupported) {
      const storageData = sessionStorage.getItem(key);

      if (!storageData) {
        return false;
      }

      try {
        return JSON.parse(sessionStorage.getItem(key));
      } catch (e) {
        return false;
      }
    }
    return false;
  },
  saveItem(key, value) {
    if (isSessionStorageSupported) {
      sessionStorage.setItem(key, JSON.stringify(value));
    }
  },
  removeItem(key) {
    if (isSessionStorageSupported) {
      sessionStorage.removeItem(key);
    }
  },
};

export default sessionRepository;
